import React from 'react';
import ButtonCommon from "../../../../../../common/components/ButtonCommon";
import deleteIcon from '../../../../../../common/assets/delete-24px.svg';
import download from '../../../../../../common/assets/download-24px 1.svg';
import select from '../../../../../../common/assets/select_black.svg';
import styles from './styles.module.scss';


export function FileItem({
                           fileData: {
                             fileName,
                             fileID,
                             fileTypeName,
                             fileTypeID,
                           },
                           showFileTypeColumn = true,
                           handleCloseModal,
                           allowDownloadFile,
                           allowDeleteFile,
                           allowSelectFile,
                           fileActions
                         }) {

  return (
    <div
      key={fileID}
      className={styles.filesList}
    >
      <div className={styles.cell}>{fileName}</div>
      {showFileTypeColumn && <div className={styles.cell}>{fileTypeName}</div>}
      {allowDeleteFile && (
        <ButtonCommon
          icon={deleteIcon}
          onClick={() => fileActions.handleDeleteFile(fileID)}
          customContainerStyles={styles.button}
        />
      )}
      {allowDownloadFile && (
        <ButtonCommon
          icon={download}
          onClick={() => fileActions.handleDownloadFile(fileID, fileName)}
          customContainerStyles={styles.button}
        />
      )}
      {allowSelectFile && (
        <ButtonCommon
          icon={select}
          onClick={() => {
            fileActions.handleSelectFile(fileTypeID, fileID);
            handleCloseModal();
          }}
        />
      )}
    </div>
  );
}
